class AdvertorialCountdown extends HTMLElement {
  static DURATION_MS = (1 * 3600 + 34 * 60 + 32) * 1000;

  connectedCallback() {
    this.display = this.querySelector('[data-countdown-display]');
    if (!this.display) return;

    this.storageKey = this.dataset.storageKey || 'advertorial-cta-countdown';
    this.startTime = this.getOrCreateStartTime();
    this.tick();
    this.intervalId = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) window.clearInterval(this.intervalId);
  }

  getOrCreateStartTime() {
    const now = Date.now();
    const stored = localStorage.getItem(this.storageKey);

    if (stored) {
      const startTime = parseInt(stored, 10);
      if (!Number.isNaN(startTime) && now - startTime < AdvertorialCountdown.DURATION_MS) {
        return startTime;
      }
      localStorage.removeItem(this.storageKey);
    }

    localStorage.setItem(this.storageKey, String(now));
    return now;
  }

  resetTimer() {
    localStorage.removeItem(this.storageKey);
    this.startTime = Date.now();
    localStorage.setItem(this.storageKey, String(this.startTime));
  }

  tick() {
    const elapsed = Date.now() - this.startTime;
    let remaining = AdvertorialCountdown.DURATION_MS - elapsed;

    if (remaining <= 0) {
      this.resetTimer();
      remaining = AdvertorialCountdown.DURATION_MS;
    }

    this.display.textContent = this.formatTime(remaining);
  }

  formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
}

customElements.define('advertorial-countdown', AdvertorialCountdown);
